export const Config = {
  CUSTOMER_SERVICE_API:
    process.env.REACT_APP_CUSTOMER_SERVICE_API || "/api/customer/api/v1/",
  CUSTOMER_MASTER_API:
    process.env.REACT_APP_MASTER_SERVICE_API || "/api/master/api/v1/",
  CUSTOMER_BOOKING_SERVICE_API:
    process.env.REACT_APP_BOOKING_SERVICE_API || "/api/booking/api/v1/",
  NOTIFICATION_SERVICE_API:
    process.env.REACT_APP_NOTIFICATION_SERVICE_API ||
    "/api/notification/api/v1/",
  PAYMENT_SERVICE_API:
    process.env.REACT_APP_PAYMENT_SERVICE_API ||
    "/api/payment/api/processpayment/",
  IMAGE_URL: "/api/customer/",
  CAPTCHA_KEY:
    "6LfF_RErAAAAAHKfzj7mNJWRq7gUOdnQY1UhotkF",
  // HOST_URL: process.env.REACT_APP_HOST_URL || "https://ui.kmb-dev.ults.build",
  HOST_URL: process.env.REACT_APP_HOST_URL || "https://ui.kmb-dev.ults.build",
  RAZORPAY_KEY_ID: "rzp_live_qyvNRG8coxGpxK",
  // RAZORPAY_KEY_ID: "rzp_test_iKGBG8SEmEpccD",
  CAPTCHA_KEY_ID:"6LePgwwrAAAAACi-QNRioYbSMQ3F5ZcCPWyRBpXT"
};
